// simply disabling the submit buttons results in their name attribute
// not being included in the parameters sent to the server

up.compiler('.js-disable_form_on_submit', function (form) {
  up.on(form, 'submit', function (event, form) {
    if (form.getAttribute('data-disabled') === 'true') {
      event.preventDefault()
      event.stopPropagation() // Required to stop unpoly from emitting/processing an `up:form:submit` event
      return false
    }

    form.setAttribute('data-disabled', 'true')
    return true
  })
})

export function enable(form) {
  form.removeAttribute('data-disabled')
}
